import PropTypes from "prop-types";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import LabCatalogAuthBridge from "./LabCatalogAuthBridge";
import { QuickCreateDrawer } from "lab-catalog-shell/modules/lab/catalog/components/QuickCreateDrawer";
import "lab-catalog-shell/styles/lab-catalog.css";

const NAV = [
  { path: "/lab/admin/catalog", label: "Overview", match: (p) => p === "/lab/admin/catalog" },
  { path: "/lab/admin/catalog/enterprise", label: "Catalog", match: (p) => p.includes("/enterprise") || p.includes("/browse") },
  { path: "/lab/admin/catalog/import", label: "Import", match: (p) => p.includes("/import") },
  { path: "/lab/admin/catalog/conflicts", label: "Duplicates", match: (p) => p.includes("/conflicts") },
  { path: "/lab/admin/catalog/hospital", label: "Enable tests", match: (p) => p.includes("/hospital") },
  { path: "/lab/admin/catalog/print-settings", label: "Lab profile", match: (p) => p.includes("/print-settings") },
  { path: "/lab/admin/catalog/tariffs", label: "Hospital pricing", match: (p) => p.includes("/tariffs") },
  { path: "/lab/admin/catalog/ai-review", label: "AI Suggestions", match: (p) => p.includes("/ai-review") },
];

/**
 * Catalog section nav + auth bridge. Each child screen wraps content in C1ListPanel.
 */
export default function LabCatalogC1Layout({ pilotProvider: PilotProvider }) {
  const location = useLocation();
  const navigate = useNavigate();
  const current =
    NAV.find((n) => n.match(location.pathname))?.path ?? "/lab/admin/catalog";

  return (
    <LabCatalogAuthBridge>
      <PilotProvider>
        <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "background.paper", px: { xs: 1, sm: 2 } }}>
          <Tabs
            value={current}
            onChange={(_, value) => navigate(value)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ minHeight: 42, "& .MuiTab-root": { minHeight: 42, py: 1, fontSize: "0.8rem", fontWeight: 700 } }}
          >
            {NAV.map((item) => (
              <Tab key={item.path} label={item.label} value={item.path} />
            ))}
          </Tabs>
        </Box>
        <Outlet />
        <QuickCreateDrawer />
      </PilotProvider>
    </LabCatalogAuthBridge>
  );
}

LabCatalogC1Layout.propTypes = {
  pilotProvider: PropTypes.elementType.isRequired,
};
